// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"_2MHI4","pdiBannerText":"_3LXHV","imageWrapperBox":"_1TDeM","bannerTextWrapper":"vIrKk","preDeliveryInspectionBanner":"_c6Cm"};